import React from "react";
// import comingsoonpdf from "../images/Coming-soon.pdf";
import comingsoonpdf from "./images/Coming-Soon.pdf"

const comingSoon = comingsoonpdf;

export default comingSoon;
